// tslint:disable: no-any
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HttpUtility {

  protected httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8'
    })
  };

  protected httpOptionsBlob = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8'
    }),
    observe: 'response' as 'body',
    responseType: 'blob' as 'json'
  };

  protected httpOptionsClaim = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      Accept: 'application/json',
      responseType: 'json'
    })
  };

  constructor(
    private httpClient: HttpClient
  ) {
  }

  getNoResult(url: string): Observable<any> {
    return this.httpClient
      .get<any>(url);
  }

  get<T>(url: string, options?: any): Observable<any> {
    return this.httpClient
      .get<T>(url, options);
  }

  postNoResult(url: string, body: any): Observable<any> {
    return this.httpClient
      .post<any>(url, JSON.stringify(body), this.httpOptions);
  }

  post<T>(url: string, body?: any): Observable<T> {
    return this.httpClient
      .post<T>(url, JSON.stringify(body), this.httpOptions);
  }

  postBlob(url: string, body?: any): Observable<any> {
    return this.httpClient.post<any>(url, JSON.stringify(body), this.httpOptionsBlob);
  }

  getBlob(url: string): Observable<any> {
    return this.httpClient.get<any>(url, this.httpOptionsBlob);
  }

  postClaim<T>(url: string, body?: any): Observable<T> {
    return this.httpClient
      .post<T>(url, JSON.stringify(body), this.httpOptionsClaim);
  }

  put<T>(url: string, body?: any): Observable<T> {
    return this.httpClient
      .put<T>(url, JSON.stringify(body), this.httpOptions);
  }

  postForDelete<T>(url: string): Observable<T> {
    return this.httpClient
      .post<T>(url, this.httpOptions);
  }

  delete<T>(url: string, options?: any): Observable<any> {
    return this.httpClient
      .delete<T>( url, options);
  }
}
